import styles from './Store.module.css';
import { canTypeForNumInput } from "../../../utils/numbers";

import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';

const ManagerInfo = ({
   data,
   section,
   handelChange,
   handelChangeBirthDate,
   nextSection,
   prevSection,
}) => {

   const allCompleted = (
      data.details.managerName &&
      data.details.managerBirthDate &&
      data.details.managerNationalId &&
      data.details.managerNationalIdSerial &&
      data.details.managerPhoneNumber
   );
   return (
      <div
         style={{ minHeight: 'fit-content' }}
         className={section === 2 ? "progresstabs__content active-nav" : "progresstabs__content"}
      >
         {/* <h1 className="progresstabs__content-title">
            مشخصات فروشگاه
         </h1> */}

         <div className={`progresstabs__content-receiver ${styles.fields}`}>
            {/* نام مدیر  */}
            <div className={`progresstabs__content-receiver-content ${styles.field}`}>
               <label className={`progresstabs__content-receiver-label ${styles.progresstabs__content_receiver_label}`}>
                  نام مدیر
                  <input
                     type="text"
                     className="progresstabs__content-receiver-input"
                     name='managerName'
                     value={data.details.managerName}
                     onChange={handelChange}
                  />
               </label>
            </div>
            {/* تاریخ تولد  */}
            <div className={`progresstabs__content-receiver-content ${styles.field}`}>
               <div className={`progresstabs__content-receiver-label ${styles.progresstabs__content_receiver_label}`}>
                  تاریخ تولد
                  <DatePicker
                     editable={false}
                     value={data.details.managerBirthDate}
                     onChange={handelChangeBirthDate}
                     calendar={persian}
                     locale={persian_fa}
                  />
               </div>
            </div>
            {/* کد ملی  */}
            <div className={`progresstabs__content-receiver-content ${styles.field}`}>
               <label className={`progresstabs__content-receiver-label ${styles.progresstabs__content_receiver_label}`}>
                  کد ملی
                  <input
                     type="number"
                     className="progresstabs__content-receiver-input"
                     name='managerNationalId'
                     value={data.details.managerNationalId}
                     onChange={handelChange}
                     onKeyDown={canTypeForNumInput}
                  />
               </label>
            </div>
            {/* سریال کارت ملی  */}
            <div className={`progresstabs__content-receiver-content ${styles.field}`}>
               <label className={`progresstabs__content-receiver-label ${styles.progresstabs__content_receiver_label}`}>
                  سریال کارت ملی
                  <input
                     type="text"
                     className="progresstabs__content-receiver-input"
                     name='managerNationalIdSerial'
                     value={data.details.managerNationalIdSerial}
                     onChange={handelChange}
                  />
               </label>
            </div>
            {/*  تلفن همراه   */}
            <div className={`progresstabs__content-receiver-content ${styles.field}`}>
               <label className={`progresstabs__content-receiver-label ${styles.progresstabs__content_receiver_label}`}>
                  تلفن همراه
                  <input
                     type="number"
                     name='managerPhoneNumber'
                     value={data.details.managerPhoneNumber}
                     onChange={handelChange}
                     className="progresstabs__content-receiver-input"
                     onKeyDown={canTypeForNumInput}
                  />
               </label>
            </div>
         </div>
         <div className="progresstabs__content-buttons" style={{ gap: '16px' }}>
            {/* <button
               className={`btn btn--secondary return-btn ${styles.btn}`}
               onClick={prevSection}
            >
               بازگشت
            </button>
            <button
               className={`btn btn--secondary next-btn ${styles.btn}`}
               onClick={nextSection}
            >
               تایید و ادامه
            </button> */}
            <button
               style={{
                  height: '50px',
                  padding: '1rem 2rem',
                  minWidth: '135px',
                  borderRadius: '4px',
                  outline: 'none',
                  border: 'none',
                  color: '#fff',
                  cursor: 'pointer',
                  background: '#21164b',
               }}
               onClick={prevSection}
            >
               بازگشت
            </button>
            <button
               style={{
                  height: '50px',
                  padding: '1rem 2rem',
                  minWidth: '135px',
                  borderRadius: '4px',
                  outline: 'none',
                  border: 'none',
                  color: '#fff',
                  cursor: 'pointer',
                  background: '#21164b',
                  ...(allCompleted ? {} : { opacity: '0.7' })
               }}
               // className={`btn btn--secondary next-btn ${styles.btn}`}
               onClick={allCompleted ? nextSection : undefined}
            >
               تایید و ادامه
            </button>
         </div>
      </div>
   );
};

export default ManagerInfo;